import script from "./ProjectInvestInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectInvestInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectInvestInfo.vue?vue&type=style&index=0&id=469baf2d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-469baf2d"]])

export default __exports__